import * as scriptjs from "scriptjs";

export default class LoadScript {
    public static load(src: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            scriptjs(src, resolve.bind(Promise, true), reject.bind(Promise, false));
        });
    }

    public static async loadSync(srcPaths: string[]): Promise<{}> {
        const promises: any = [];
        if (!srcPaths.length) { return {}; }
        srcPaths.forEach(srcPath => {
            promises.push(LoadScript.load.bind(LoadScript, srcPath));
        });
        return await LoadScript.serializePromise(promises);
    }

    private static serializePromise(funcs): Promise<{}> {
        return funcs.reduce((promise, func) =>
            promise.then(() => {
                return func().then((result) => {
                    Array.prototype.concat.bind(result);
                });
            }),
            Promise.resolve([])
        );
    }

    public static async loadAll(srcPaths: string[])
        : Promise<{}> {
        if (!srcPaths.length) { return {}; }
        const promises: Promise<boolean>[] = [];
        srcPaths.forEach((srcPath) => {
            promises.push(LoadScript.load(srcPath));
        });
        return Promise.all(promises);
    }
}
